export enum PRIVILEGE {
  VENTE_NORMALE = 1,
  VENTE_ASSOCIATION = 2,
  ADD_ENCAISSEMENT = 3,
  CONSULTATION = 4,
  LIST_VENTES = 5,
  MY_VENTES = 19,
  ADD_CLIENT = 6,
  EDIT_CLIENTS = 7,
  PLAN_MASSE = 9,
  CONSULTATION_COMPTA = 10,
  PORTEFEUILLE_BUREAU_VENTE = 11,
  PORTEFEUILLE_SIEGE = 20,
  PORTEFEUILLE_COMPTA = 21,
  A_VERSER = 22,
  SPECIAL_COMPTA = 23,
  ENCAISSE_IMPAYE = 24,
  LIST_ENCAISSEMENTS = 25,
  LIST_ENCAISSES = 26,
  LIST_IMPAYES = 27,
  ETAT_PORTEFEUILLE = 28,
  LISTE_EN_INSTANCE = 29,
  USERS = 12,
  LIST_CLIENTS = 8,
  BANQUES_VIREMENT = 13,
  PARC_INFORMATIQUE = 14,
  CHANGEMENT_PRIX = 15,
  DEBLOCAGE_BLOCAGE = 16,
  ASSOCIATION_ADMIN = 17,
  REMISE_ADMIN = 18,
  WEBMASTER = 30,
  EDIT_CHARGE = 31,
  POURCENTAGES_PARTS = 32,
  NOTAIRE_EN_COURS = 33,
  SIGNE_NOTAIRE = 34,
  SUMMARY_PROJECT = 35,
  ACCESS_ALL_USERS = 36,
  DESISTEMENT = 37,
  TRANSFERT = 38,
  CHANGEMENT_BIEN = 39,
  REPLACE_ENCAISSEMENT = 40,
  COMMISSIONS_PAGE = 41,
  OTHERS_COMMISSIONS = 42,
  SEE_COMMISSIONS_FORMULAS = 43,
  EDIT_COMMISSIONS_FORMULAS = 44,
  COMMISSIONS_BULLETIN = 45,
  EDIT_COMMISSIONS = 46,
  VALIDATE_COMMISSIONS = 47,
  EDIT_GOALS = 48,
  EDIT_ASSOCIATION = 49,
  LIST_GOALS = 50,
  LIST_BUDGETS = 51,
  EDIT_BUDGETS = 52,
  EDIT_CONTRAT_MONTH = 53,
  LIST_BIEN = 54,
  SEE_PRIX_MIN = 55,
  EDIT_PRIX_MIN = 56,
  OWN_GOAL = 57,
  ACCESS_NOTAIRE = 58,
  EDIT_ENCAISSEMENT = 59,
  ACCESS_HIDDEN_BIENS = 60,
  ADD_VISITORS = 61,
  LIST_VISITORS = 62,
  TEMP_BLOCK = 63,
  ADD_DIVISION = 64,
  APPROVE_DIVISION = 65,
  LIST_ENCAISSEMENTS_NOTAIRE = 66,
  FICHE_DESISTEMENT = 67,
  SEND_ENC_TO_COMPTA = 68,
  EXPEDITION_MINUTE = 69,
  ENREGISTREMENT_MINUTE = 70,
  VALIDATION_ENC = 71,
  RAPPROCHEMENT_ENC = 72,
  MANAGE_NOTIFICATIONS = 73,
}